import { useTranslation } from 'react-i18next'
import { FaFileExcel, FaFilePdf, FaSearch, FaSync } from 'react-icons/fa'
import DatePicker from './DatePicker'
import DropdownField from './DropdownField'
import TextInput from './TextInput'
import CustomButton from './CustomButton'
import AutoCompleteField from './AutoCompleteField'
import MultiSelectField from './MultiSelectField'

const ReportFilters = ({
  filters,
  onChange,
  filterConfig = [],
  onGenerate,
  onReset,
  loading = false,
  extraActions = null,
  generateIcon,
  generateButtonType
}) => {
  const { t } = useTranslation()

  const renderField = (field) => {
    const commonProps = {
      name: field.name,
      useFormik: false,
      value: filters[field.name],
      onChange: onChange,
      className: '!mb-0 !w-full'
    }

    switch (field.type) {
      case 'date':
        return (
          <div key={field.name} className={field.width || 'w-[160px]'}>
            {field.label && (
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t(field.label)}
              </label>
            )}
            <DatePicker
              {...commonProps}
              minDate={field.minDate}
              maxDate={field.maxDate}
              label={field.showLabel ? t(field.label) : undefined}
            />
          </div>
        )

      case 'dropdown':
        return (
          <div key={field.name} className={field.width || 'w-[160px]'}>
            <DropdownField
              {...commonProps}
              handleChange={onChange}
              label={t(field.label)}
              options={field.options || []}
              placeholder={field.placeholder ? t(field.placeholder) : undefined}
              filter={field.filter}
              multiple={field.multiple}
              disabled={field.disabled}
            />
          </div>
        )

      case 'multiselect':
        return (
          <div key={field.name} className={field.width || 'w-[240px]'}>
            <MultiSelectField
              useFormik={false}
              name={field.name}
              label={t(field.label)}
              value={filters[field.name] || []}
              handleChange={onChange}
              options={field.options || []}
              optionLabel={field.optionLabel || 'label'}
              optionValue={field.optionValue || 'value'}
              optionGroupLabel={field.optionGroupLabel}
              optionGroupChildren={field.optionGroupChildren}
              placeholder={field.placeholder ? t(field.placeholder) : undefined}
              filter={field.filter}
              display={field.display || 'chip'}
              maxSelectedLabels={field.maxSelectedLabels}
              selectedItemsLabel={field.selectedItemsLabel ? t(field.selectedItemsLabel) : undefined}
              disabled={field.disabled}
              className='!mb-0 !w-full'
            />
          </div>
        )

      case 'text':
        return (
          <div key={field.name} className={field.width || 'w-[160px]'}>
            <TextInput
              {...commonProps}
              label={t(field.label)}
              handleChange={onChange}
              placeholder={field.placeholder ? t(field.placeholder) : undefined}
              parentClass='!mb-0'
            />
          </div>
        )

      case 'autocomplete':
        return (
          <div key={field.name} className={field.width || 'w-[220px]'}>
            <AutoCompleteField
              useFormik={false}
              name={field.name}
              inputId={field.name}
              inputName={field.name}
              label={field.label ? t(field.label) : ''}
              value={filters[field.name] || null}
              fieldUrl={field.fieldUrl}
              queryKey={field.queryKey || 'query'}
              payload={field.payload || {}}
              optionsFormat={field.optionsFormat}
              forceSelection={false}
              onChange={onChange}
              placeholder={field.placeholder ? t(field.placeholder) : undefined}
              className='!w-full'
              parentClass='!mb-0'
            />
          </div>
        )

      default:
        return null
    }
  }

  return (
    <div className='bg-white flex mb-2 flex-wrap items-end gap-3'>
      {filterConfig.map(renderField)}

      <div className='flex gap-2 items-end'>
        <CustomButton
          icon={generateIcon || (filters.format === 'pdf' ? FaFilePdf : FaFileExcel)}
          onClick={onGenerate}
          loading={loading}
          disabled={loading}
          buttonType={generateButtonType || (filters.format === 'pdf' ? 'danger' : 'success')}
          className='h-[38px]'
        />
        {onReset && (
          <CustomButton
            icon={FaSync}
            onClick={onReset}
            disabled={loading}
            className='h-[38px]'
          />
        )}
        {extraActions}
      </div>
    </div>
  )
}

export default ReportFilters
